module.exports = __webpack_public_path__ + "static/fonts/Fact-BoldItalic.cc855a5.ttf";